module.exports = __webpack_public_path__ + "static/media/right_arr.ff2b9671.svg";